// action types

// poi bank
export const FETCH_POI_BANK_INIT_SUCCESS = 'fetchPoiBankInitSuccess';
export const FETCH_POI_BANK_INIT_FAIL = 'fetchPoiBankInitFail';
export const FETCH_POI_BANK_INIT = 'fetchPoiBankInit';
export const FETCH_POI_DETAIL_FROM_POI_BANK_SUCCESS =
  'fetchPoiDetailFromPoiBankSuccess';
export const FETCH_POI_DETAIL_FROM_POI_BANK_FAIL =
  'fetchPoiDetailFromPoiBankFail';
export const FETCH_POI_DETAIL_FROM_POI_BANK = 'fetchPoiDetailFromPoiBank';
export const FETCH_CITY_AUTOCOMPLETE_SUCCESS = 'fetchCityAutocompleteSuccess';
export const FETCH_CITY_AUTOCOMPLETE_FAIL = 'fetchCityAutocompleteFail';
export const FETCH_CITY_AUTOCOMPLETE = 'fetchCityAutocomplete';
export const CLEAR_CITY_AUTOCOMPLETE = 'clearCityAutocomplete';
export const FETCH_RECOMMENDED_POI_SUCCESS = 'fetchRecommendedPoiSuccess';
export const FETCH_RECOMMENDED_POI_FAIL = 'fetchRecommendedPoiFail';
export const FETCH_RECOMMENDED_POI = 'fetchRecommendedPoi';
export const RESET_RECOMMENDED_POI = 'RESET_RECOMMENDED_POI';
export const SET_RECOMMENDED_POI = 'SET_RECOMMENDED_POI';
export const SEARCH_POI_SUCCESS = 'searchPoiSuccess';
export const SEARCH_POI_FAIL = 'searchPoiFail';
export const SEARCH_POI = 'searchPoi';
export const POI_BANK_CITY_GEOCODE_SUCCESS = 'poiBankCityGeocodeSuccess';
export const POI_BANK_CITY_GEOCODE_FAIL = 'poiBankCityGeocodeFail';
export const POI_BANK_CITY_GEOCODE = 'poiBankCityGeocode';
export const CLEAR_POI_LIST = 'clearPoiList';
export const SET_TRANSPORTATION_AIRPLANE_TYPE = 'setTransportationAirplaneType';
export const SET_AIRPLANE_APPROXIMATE_TRANSPORTATION_TIME_FLAG =
  'SET_AIRPLANE_APPROXIMATE_TRANSPORTATION_TIME_FLAG';

// funliday server
export const FETCH_INIT_SUCCESS = 'fetchInitSuccess';
export const FETCH_INIT_FAIL = 'fetchInitFail';
export const FETCH_INIT = 'fetchInit';
export const FETCH_POIS_SUCCESS = 'fetchPoisSuccess';
export const FETCH_POIS_FAIL = 'fetchPoisFail';
export const FETCH_POIS = 'fetchPois';
export const FETCH_POI_DETAIL_SUCCESS = 'fetchPoiDetailSuccess';
export const FETCH_POI_DETAIL_FAIL = 'fetchPoiDetailFail';
export const FETCH_POI_DETAIL = 'fetchPoiDetail';
export const FETCH_POI_ROUTE_SUCCESS = 'fetchPoiRouteSuccess';
export const FETCH_POI_ROUTE_FAIL = 'fetchPoiRouteFail';
export const FETCH_POI_ROUTE = 'fetchPoiRoute';
export const FETCH_TEXT_NOTE_SUCCESS = 'fetchTextNoteSuccess';
export const FETCH_TEXT_NOTE_FAIL = 'fetchTextNoteFail';
export const FETCH_TEXT_NOTE = 'fetchTextNote';
export const FETCH_MY_TRIP_LIST_SUCCESS = 'fetchMyTripListSuccess';
export const FETCH_MY_TRIP_LIST_FAIL = 'fetchMyTripListFail';
export const FETCH_MY_TRIP_LIST = 'fetchMyTripList';
export const FETCH_TRAVEL_GROUP_LIST_SUCCESS = 'fetchTravelGroupListSuccess';
export const FETCH_TRAVEL_GROUP_LIST_FAIL = 'fetchTravelGroupListFail';
export const FETCH_TRAVEL_GROUP_LIST = 'fetchTravelGroupList';
export const UPDATE_PUBLIC_STATUS_SUCCESS = 'updatePublicStatusSuccess';
export const UPDATE_PUBLIC_STATUS_FAIL = 'updatePublicStatusFail';
export const UPDATE_PUBLIC_STATUS = 'updatePublicStatus';
export const UPDATE_START_TIME_SUCCESS = 'updateStartTimeSuccess';
export const UPDATE_START_TIME_FAIL = 'updateStartTimeFail';
export const UPDATE_START_TIME = 'updateStartTime';
export const UPDATE_STAY_TIME_SUCCESS = 'updateStayTimeSuccess';
export const UPDATE_STAY_TIME_FAIL = 'updateStayTimeFail';
export const UPDATE_STAY_TIME = 'updateStayTime';
export const POST_ROUTE_SUCCESS = 'postRouteSuccess';
export const POST_ROUTE_FAIL = 'postRouteFail';
export const POST_ROUTE = 'postRoute';
export const UPDATE_TRIP_INFO_SUCCESS = 'updateTripInfoSuccess';
export const UPDATE_TRIP_INFO_FAIL = 'updateTripInfoFail';
export const UPDATE_TRIP_INFO = 'updateTripInfo';
export const COPY_POI_SUCCESS = 'copyPoiSuccess';
export const COPY_POI_FAIL = 'copyPoiFail';
export const COPY_POI = 'copyPoi';
export const REMOVE_POIS_SUCCESS = 'removePoisSuccess';
export const REMOVE_POIS_FAIL = 'removePoisFail';
export const REMOVE_POIS = 'removePois';
export const POST_TEXT_NOTE_SUCCESS = 'postTextNoteSuccess';
export const POST_TEXT_NOTE_FAIL = 'postTextNoteFail';
export const POST_TEXT_NOTE = 'postTextNote';
export const EDIT_ALIAS_NAME_SUCCESS = 'editAliasNameOfPoiSuccess';
export const EDIT_ALIAS_NAME_FAIL = 'editAliasNameOfPoiFail';
export const EDIT_ALIAS_NAME = 'editAliasNameOfPoi';
export const CUSTOMIZE_TRANSPORTATION_TIME_SUCCESS =
  'customizeTransportationTimeSuccess';
export const CUSTOMIZE_TRANSPORTATION_TIME_FAIL =
  'customizeTransportationTimeFail';
export const CUSTOMIZE_TRANSPORTATION_TIME = 'customizeTransportationTime';
export const ONE_MORE_DAY_SUCCESS = 'oneMoreDaySuccess';
export const ONE_MORE_DAY_FAIL = 'oneMoreDayFail';
export const ONE_MORE_DAY = 'oneMoreDay';
export const MORE_DAYS_SUCCESS = 'MoreDaysSuccess';
export const MORE_DAYS_FAIL = 'MoreDaysFail';
export const MORE_DAYS = 'MoreDays';
export const REMOVE_DAYS_SUCCESS = 'removeDaysSuccess';
export const REMOVE_DAYS_FAIL = 'removeDaysFail';
export const REMOVE_DAYS = 'removeDays';
export const ADD_POI_SUCCESS = 'addPoiSuccess';
export const ADD_POI_FAIL = 'addPoiFail';
export const ADD_POI = 'addPoi';
export const GEO_CODE_SUCCESS = 'geocodeSuccess';
export const GEO_CODE_FAIL = 'geocodeFail';
export const GEO_CODE = 'geocode';
export const UPDATE_PERMISSION_OF_TRIP_SUCCESS =
  'updatePermissionOfTripSuccess';
export const UPDATE_PERMISSION_OF_TRIP_FAIL = 'updatePermissionOfTripFail';
export const UPDATE_PERMISSION_OF_TRIP = 'updatePermissionOfTrip';
export const SYNC_REMOVE_TRAVEL_COMPANIONS_SUCCESS =
  'syncRemoveTravelCompanionsSuccess';
export const SYNC_REMOVE_TRAVEL_COMPANIONS_FAIL =
  'syncRemoveTravelCompanionsFail';
export const SYNC_REMOVE_TRAVEL_COMPANIONS = 'syncRemoveTravelCompanions';
export const REINDEX_POI_SEQUENCE_SUCCESS = 'reindexPoiSequenceSuccess';
export const REINDEX_POI_SEQUENCE_FAIL = 'reindexPoiSequenceFail';
export const REINDEX_POI_SEQUENCE = 'reindexPoiSequence';
export const REINDEX_DAY_SEQUENCE_SUCCESS = 'reindexDaySequenceSuccess';
export const REINDEX_DAY_SEQUENCE_FAIL = 'reindexDaySequenceFail';
export const REINDEX_DAY_SEQUENCE = 'reindexDaySequence';
export const REARRANGE_POI_SEQUENCE_SUCCESS = 'rearrangePoiSequenceSuccess';
export const REARRANGE_POI_SEQUENCE_FAIL = 'rearrangePoiSequenceFail';
export const REARRANGE_POI_SEQUENCE = 'rearrangePoiSequence';
export const ADD_TRIP_SUCCESS = 'addTripSuccess';
export const ADD_TRIP_LOADING = 'addTripLoading';
export const ADD_TRIP_FAIL = 'addTripFail';
export const ADD_TRIP = 'addTrip';
export const COPY_TRIP_SUCCESS = 'copyTripSuccess';
export const COPY_TRIP_FAIL = 'copyTripFail';
export const COPY_TRIP = 'copyTrip';
export const DELETE_TRIP = 'deleteTrip';
export const DELETE_TRIP_SUCCESS = 'deleteTripSuccess';
export const DELETE_TRIP_FAIL = 'deleteTripFail';
export const DELETE_SHARED_TRIP = 'deleteSharedTrip';
export const DELETE_SHARED_TRIP_SUCCESS = 'deleteSharedTripSuccess';
export const DELETE_SHARED_TRIP_FAIL = 'deleteSharedTripFail';
export const GET_COUNT_OF_INVITATIONS = 'getCountOfInvitations';
export const GET_COUNT_OF_INVITATIONS_SUCCESS = 'getCountOfInvitationsSuccess';
export const GET_COUNT_OF_INVITATIONS_FAIL = 'getCountOfInvitationsFail';
export const ACCEPT_SHARED_TRIP = 'acceptSharedTrip';
export const ACCEPT_SHARED_TRIP_SUCCESS = 'acceptSharedTripSuccess';
export const ACCEPT_SHARED_TRIP_FAIL = 'acceptSharedTripFail';
export const ACCEPT_SEND_ITINERARY = 'acceptSendItinerary';
export const ACCEPT_SEND_ITINERARY_SUCCESS = 'acceptSendItinerarySuccess';
export const ACCEPT_SEND_ITINERARY_FAIL = 'acceptSendItineraryFail';
export const LISTEN_CONNECT_REVISION = 'listenConnectRevision';

// Itinerary
export const COPY_TRIP_FROM_ITINERARY = {
  INIT: 'copyTripFromItineraryInit',
  LOADING: 'copyTripFromItineraryLoading',
  SUCCESS: 'copyTripFromItinerarySuccess',
  FAIL: 'copyTripFromItineraryFail'
};
export const SET_NORTHEAST_AND_SOUTHEAST = 'setNorthEast&SouthEast';

// collections
export const FETCH_MY_COLLECTIONS = 'fetchMyCollections';
export const FETCH_MY_COLLECTIONS_SUCCESS = 'fetchMyCollectionsSuccess';
export const FETCH_MY_COLLECTIONS_FAIL = 'fetchMyCollectionsFail';
export const FETCH_SHARED_COLLECTIONS_FOLDERS = 'fetchSharedCollectionsFolders';
export const FETCH_SHARED_COLLECTIONS_FOLDERS_SUCCESS =
  'fetchSharedCollectionsFoldersSuccess';
export const FETCH_SHARED_COLLECTIONS_FOLDERS_FAIL =
  'fetchSharedCollectionsFoldersFail';
export const FETCH_MY_COLLECTIONS_IN_FOLDER = 'fetchMyCollectionsInFolder';
export const FETCH_MY_COLLECTIONS_IN_FOLDER_SUCCESS =
  'fetchMyCollectionsInFolderSuccess';
export const FETCH_MY_COLLECTIONS_IN_FOLDER_FAIL =
  'fetchMyCollectionsInFolderFail';
export const ADD_POI_TO_COLLECTIONS = 'addPoiToCollection';
export const ADD_POI_TO_COLLECTIONS_SUCCESS = 'faddPoiToCollectionSuccess';
export const ADD_POI_TO_COLLECTIONS_FAIL = 'addPoiToCollectionFail';

export const ERASE_TRIP_LIST = 'eraseTripList';

// view state
export const VIEW_STATE = 'viewState';

// view types
export const SHOW_POI_DETAIL = 'showPoiDetail';
export const SHOW_POI_ROUTE = 'showPoiRoute';
export const SHOW_ADD_POI = 'showAddPoi';
export const SHOW_DAY_MODE_ON_MAP = 'showDayModeOnMap';
export const SET_POI_DETAIL_TAB = 'setPoiDetailTab';
export const SCROLL_TO_DAY = 'scrollToDay';
export const SHOW_EDIT_MODE = 'showEditMode';
export const RESET_ITINERARY = '[itinerary] resetItinerary';
export const SHOW_FOLDER_DETAIL = 'showFolderDetail';
export const SHOW_ORDER_DETAIL = 'showOrderDetail';
export const SHOW_NOTE_DETAIL = 'showNoteDetail';
export const RESET_DATE_OUT_STATUS = 'resetDataOutStatus';

// toast
export const SHOW_TOAST = 'showToast';
export const HIDDEN_TOAST = 'hiddenToast';

// request status
export const REQUEST_INIT = 'requestInit'; // 註：推測 REQUEST_NORMAL 應該是指初始化 init 還沒 AJAX 過的意思,礙於太多用到,若日後有修改應改成 REQUEST_INIT 叫語意化
export const REQUEST_NORMAL = 'requestNormal';
export const REQUEST_LOADING = 'requestLoading';
export const REQUEST_SUCCESS = 'requestSuccess';
export const REQUEST_FAIL = 'requestFail';
export const REQUEST = {
  INIT: 'requestInit',
  LOADING: 'requestLoading',
  SUCCESS: 'requestSuccess',
  FAIL: 'requestFail'
};

// locale
export const LANGUAGE_DETECTED = 'languageDetected';

// member
export const USER_LOGIN = 'userLogin';
export const USER_LOGIN_SUCCESS = 'userLoginSuccess';
export const USER_LOGIN_FAIL = 'userLoginFail';
export const USER_LOGIN_WITHOUT_EMAIL = 'userLoginWithoutEmail';
export const USER_LOG_OUT = 'userLogOut';
export const LOAD_DATA_FROM_LOCAL_STORAGE = 'loadDataFromLocalStorage';

// direction
export const CHANGE_TRANSPORTATION_TYPE = 'changeTransportationType';
export const CHANGE_TRANSPORTATION_TYPE_SUCCESS =
  'changeTransportationTypeSuccess';
export const CHANGE_TRANSPORTATION_TYPE_FAIL = 'changeTransportationTypeFail';
export const TRIGGER_DIRECTION_MANAGER = 'triggerDirectionManager';
export const CHANGE_ROUTING_PREFERENCES = 'changeRoutingPreferences';

// search poi
export const CACHE_SEARCH_CITY = 'cacheSearchCity';

// edit Member data
export const SET_MEMBER_USERID = 'setMemberUserID';
export const SET_MEMBER_NICKNAME = 'setMemberNickname';
export const SET_MEMBER_GENDER = 'setMemberGender';
export const SET_MEMBER_DESCRIPTION = 'setMemberDescription';

// journals like
export const FETCH_JOURNAL_LIKE_SUCCESS = 'fetchJournalsLikeSuccess';
export const FETCH_JOURNAL_LIKE_FAIL = 'fetchJournalsLikeFail';
export const FETCH_JOURNAL_LIKE_LOADING = 'fetchJournalsLikeLoding';

// my trips group
export const REMOVE_MEMBER_FROM_GROUP_OF_MY_TRIPS =
  'removeMemberFromGroupOfMyTrips';

// my trips list
export const RESET_MY_TRIP_LIST = 'resetMyTripsList';

// trips comments
export const SET_TRIPS_COMMENTS = 'setTripsComments';
export const SET_TRIPS_REPLYS = 'setTripsReplys';
export const DELETE_TRIPS_COMMENTS = 'deleteTripsComments';
export const DELETE_TRIPS_REPLYS = 'deleteTripsReplys';
export const SET_NEXT_TRIPS_COMMENTS = 'setNextTripsComments';
export const SET_NEXT_TRIPS_REPLY = 'setNextTripsReply';
export const FETCH_TRIPS_COMMENTS_LOADING = 'fetchTripsCommentsLoading';
export const FETCH_TRIPS_COMMENTS_SUCCESS = 'fetchTripsCommentsSuccess';
export const FETCH_TRIPS_COMMENTS_FAIL = 'fetchTripsCommentsFail';

// myTrips
export const GET_MYTRIP_LIST_SUCCESS = 'getMyTripListSuccess';
export const GET_MYTRIP_LIST_FAIL = 'getMyTripListFail';
export const GET_MYTRIP_LIST_LOADING = 'getMyTripListLoading';
export const GET_MYTRIP_LIST_INIT = 'getMyTripListInit';
export const GET_NEXT_MYTRIP_LIST_SUCCESS = 'getNextMyTripListSuccess';
export const GET_NEXT_MYTRIP_LIST_FAIL = 'getNextMyTripListFail';
export const GET_NEXT_MYTRIP_LIST_LOADING = 'getNextMyTripListLoading';
export const SHOW_SHARE_MYTRIP_BOX = 'showShareTripBox';
export const CLEAN_SHARE_MYTRIP_BOX = 'cleanShareMyTripBox';
export const POST_TRIP_PUBLIC_STATUS_LOADING = 'postTripPublicStatusLoading';
export const POST_TRIP_PUBLIC_STATUS_SUCCESS = 'postTripPublicStatusSuccess';
export const POST_TRIP_PUBLIC_STATUS_FAIL = 'postTripPublicStatusFail';
export const RESET_POST_TRIP_PUBLIC_STATUS = 'resetPostTripPublicStatus';
export const SHOW_ADD_GROUP_BOX = 'showAddGroupBox';
export const CLEAN_ADD_GROUP_BOX = 'cleanAddFroupBox';
export const SET_INVITATION_LINK = 'setInvitationLink';
export const UPDATE_MEMBERS_OF_GROUP = 'updateMembersOfGroup';
export const DELETE_MY_TRIP_SUCCESS = 'deleteMyTripSuccess';
export const DELETE_MY_TRIP_FAIL = 'deleteMyTripFail';
export const SET_TRIP_ITEM_LOADING = 'setTripItemLoading';
// onBording
export const ONBOARDING_BOX = {
  SHOW: 'showOnboardingBox',
  CLOSE: 'closeOnboardingBox'
};
export const CHECK_DELETE_MYTRIPS = {
  SHOW: 'showCheckDeleteMyTripsPopup',
  CLOSE: 'closeCheckDeleteMyTripsPopup'
};
export const GET_TEMPLETE_TRIP = {
  LOADING: 'getTempleteTripLoading',
  SUCCESS: 'getTempleteTripSuccess',
  FAIL: 'getTempleteTripFail'
};
export const SET_ONBOARDING_STEP = {
  GO_ADD_TRIP: 'goToAddTripStep',
  BACK_TEMPLETE: 'backToSelectTempleteSrep',
  GO_DATE: 'goToSelectDateStep',
  GO_DATE_RECOMMEND_TRIP: 'goToSelectRecommendTripDateStep'
};
export const COPY_ON_BOARDING = {
  LOADING: 'copyOnboardingLoading',
  SUCCESS: 'copyOnboardingSuccess',
  FAIL: 'copyOnboardingFail'
};
export const SET_ONBOARDING_DATE = 'setOnboardingDate';

// myTrips & groupTrips common
export const RESET_MYTRIP_PAGE_STATE = 'resetMyTripPageState';

// groupTrips
export const GET_GROUPTRIP_LIST_SUCCESS = 'getGroupTripListSuccess';
export const GET_GROUPTRIP_LIST_FAIL = 'getGroupTripListFail';
export const GET_GROUPTRIP_LIST_LOADING = 'getGroupTripListLoading';
export const GET_GROUPTRIP_LIST_INIT = 'getGroupTripListInit';
export const GET_NEXT_GROUPTRIP_LIST_SUCCESS = 'getNextGroupTripListSuccess';
export const GET_NEXT_GROUPTRIP_LIST_FAIL = 'getNextGroupTripListFail';
export const GET_NEXT_GROUPTRIP_LIST_LOADING = 'getNextGroupTripListLoading';
export const SHOW_WATCH_GROUP_BOX = 'showWatchGroupBox';
export const CLOSE_WATCH_GROUP_BOX = 'closeWatchGroupBox';
export const SHOW_SHARE_GROUPTRIP_BOX = 'showShareGroupTripBox';
export const CLOSE_SHARE_GROUPTRIP_BOX = 'closeShareGroupTripBox';
export const POST_GROUPTRIP_PUBLIC_STATUS_LOADING =
  'postGroupTripPublicStatusLoading';
export const POST_GROUPTRIP_PUBLIC_STATUS_SUCCESS =
  'postGroupTripPublicStatusSuccess';
export const POST_GROUPTRIP_PUBLIC_STATUS_FAIL =
  'postGroupTripPublicStatusFail';
export const DELETE_GROUPTRIP_SUCCESS = 'deleteGroupTripSuccess';
export const DELETE_GROUPTRIP_FAIL = 'deleteGroupTripFail';
export const SET_GROUPTRIP_ITEM_LOADING = 'setGroupTripItemLoading';

// collections Page
export const INIT_COLLECTIONS = 'initCollections';
export const GET_COLLECTIONS_LOADING = 'getCollectionsLoading';
export const GET_COLLECTIONS_SUCCESS = 'getCollectionsSuccess';
export const GET_COLLECTIONS_FAIL = 'getCollectionsFail';
export const CLEAN_COPY_COLLECTIONS_BOX = 'cleanCopyCollectionsBox';
export const SHOW_COPY_COLLECTIONS_BOX = 'showCopyCollectionsBox';
export const SET_COLLECTIONS_LIKE = 'setCollectionsLike';
export const COPY_COLLECTIONS_LOADING = 'copyCollectionsLoading';
export const COPY_COLLECTIONS_SUCCESS = 'copyCollectionsSuccess';
export const COPY_COLLECTIONS_FAIL = 'copyCollectionsFail';
export const SHOW_COLLECTIONS_SHARE = 'showCollectionsShare';
export const CLEAN_COLLECTIONS_SHARE = 'cleanCollectionsShare';
export const SET_COLLECTIONS_AUTHOR_FOLLOWING = 'setCollectionsAuthorFollowing';

// Articles Page
export const INIT_ARTICLES = 'initArticles';
export const GET_ARTICLES_LOADING = 'getArticlesLoading';
export const GET_ARTICLES_SUCCESS = 'getArticlesSuccess';
export const GET_ARTICLES_FAIL = 'getArticlesFail';
export const CLEAN_COPY_ARTICLES_BOX = 'cleanCopyArticlesBox';
export const SHOW_COPY_ARTICLES_BOX = 'showCopyArticlesBox';
export const SET_ARTICLES_LIKE = 'setArticlesLike';
export const COPY_ARTICLES_LOADING = 'copyArticlesLoading';
export const COPY_ARTICLES_SUCCESS = 'copyArticlesSuccess';
export const COPY_ARTICLES_FAIL = 'copyArticlesFail';
export const SHOW_ARTICLES_SHARE = 'showArticlesShare';
export const CLEAN_ARTICLES_SHARE = 'cleanArticlesShare';
export const GET_ARTICLES_COLLECTIONS_LOADING = 'getArticlesCollectionsLoading';
export const GET_ARTICLES_COLLECTIONS_SUCCESS = 'getArticlesCollectionsSuccess';
export const GET_ARTICLES_COLLECTIONS_FAIL = 'getArticlesCollectionsFail';
export const GET_ARTICLES_POIS_LOADING = 'getArticlesPoisLoading';
export const GET_ARTICLES_POIS_SUCCESS = 'getArticlesPoisSuccess';
export const GET_ARTICLES_POIS_FAIL = 'getArticlesPoisFail';
export const SET_ARTICLES_AUTHOR_FOLLOWING = 'setArticleAuthorFollowing';
